module.exports = __webpack_public_path__ + "static/media/logo.fw.fbe04216.png";